import { inject, InjectionToken } from '@angular/core';
import { AppTrackingStatus } from 'capacitor-plugin-app-tracking-transparency';
import { AppTrackingTransparencyService } from '../services';

export const APP_TRACKING_TRANSPARENCY_TOKEN: InjectionToken<AppTrackingTransparencyProvider> =
  new InjectionToken<AppTrackingTransparencyProvider>('APP_TRACKING_TRANSPARENCY_TOKEN', {
    factory: (): AppTrackingTransparencyProvider => {
      const service: AppTrackingTransparencyService = inject(AppTrackingTransparencyService);

      return {
        requestPermission(): Promise<AppTrackingStatus | null> {
          return service.requestPermission();
        }
      };
    }
  });

export interface AppTrackingTransparencyProvider {
  requestPermission(): Promise<AppTrackingStatus | null>;
}
